import state from './state';
import getters from './getters';
import mutations from './mutations';
import actions from './actions';
import {User} from './types';
import { Module } from 'vuex';
import { RootState } from '../types';

export const user: Module<User, RootState> = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
